export function AuthSpinner() {
  return (
    <span
      className="block size-4 rounded-full border border-current border-t-transparent motion-safe:animate-spin"
      aria-hidden="true"
    />
  );
}
